<template>
  <div class="fullview">
    <div class="clearfix">
      <vue-loading type="spin" color="#a55" :size="{ width: '100px', height: '100px' }">
      </vue-loading>
    </div>
    <template v-if="this.$store.state.isLoadingMessage">
      <div class="clearfix">
        <p class="text-light d-block text-center">デザイン送信中…</p>
        <p class="text-light d-block text-center">しばらくお待ちください</p>
      </div>
    </template>
    <template v-if="this.$store.state.isLoadingMessageFree">
      <div class="clearfix">
        <p class="text-light d-block text-center" style="width:220px;">{{this.message}}</p>
      </div>
    </template>
  </div>
</template>

<script>
import { VueLoading } from "vue-loading-template";

export default {
  name: "loading",
  components: {
    VueLoading,
  },
  computed:{
    message(){
      return this.$store.state.isLoadingMessageFree
    }
  }
};
</script>

<style scoped>
.fullview {
  width: 100%;
  height: 100%;
  background: #000000aa;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.loading-spacer {
  height: 30%;
  background-color: red;
}
.clearfix:after {
  content: "";
  display: block;
  clear: both;
}

.clearfix:before {
  content: "";
  display: block;
  clear: both;
}

.clearfix {
  display: block;
}
</style>
